import EditarPaciente from "./EditarPaciente"
import GestionMedicos from "./GestionDoctores"

function GestionPaciente() {
  return (
    <div className="column adminTabGap">
      <EditarPaciente />
      <div className="adminSeparador" />
      <GestionMedicos />
    </div>
  )
}

export default GestionPaciente
